// extracted by mini-css-extract-plugin
module.exports = {"resume":"CreateResume-module--resume--3--Zy","backdrop":"CreateResume-module--backdrop--3PoPE","page":"CreateResume-module--page--3VpQK","meta":"CreateResume-module--meta--xhJmV"};